<template>
    <div class="request-new-company-modal">
        <ModalPattern class="absolute left-0 top-0 z-[0]" />

        <div class="header">
            <div class="icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M21.75 21H19.5V3H20.25C20.4489 3 20.6397 2.92098 20.7803 2.78033C20.921 2.63968 21 2.44891 21 2.25C21 2.05109 20.921 1.86032 20.7803 1.71967C20.6397 1.57902 20.4489 1.5 20.25 1.5H3.75C3.55109 1.5 3.36032 1.57902 3.21967 1.71967C3.07902 1.86032 3 2.05109 3 2.25C3 2.44891 3.07902 2.63968 3.21967 2.78033C3.36032 2.92098 3.55109 3 3.75 3H4.5V21H2.25C2.05109 21 1.86032 21.079 1.71967 21.2197C1.57902 21.3603 1.5 21.5511 1.5 21.75C1.5 21.9489 1.57902 22.1397 1.71967 22.2803C1.86032 22.421 2.05109 22.5 2.25 22.5H21.75C21.9489 22.5 22.1397 22.421 22.2803 22.2803C22.421 22.1397 22.5 21.9489 22.5 21.75C22.5 21.5511 22.421 21.3603 22.2803 21.2197C22.1397 21.079 21.9489 21 21.75 21ZM6 3H18V21H15V17.25C15 17.0511 14.921 16.8603 14.7803 16.7197C14.6397 16.579 14.4489 16.5 14.25 16.5H9.75C9.55109 16.5 9.36032 16.579 9.21967 16.7197C9.07902 16.8603 9 17.0511 9 17.25V21H6V3ZM13.5 21H10.5V18H13.5V21ZM8.25 6C8.25 5.80109 8.32902 5.61032 8.46967 5.46967C8.61032 5.32902 8.80109 5.25 9 5.25H10.5C10.6989 5.25 10.8897 5.32902 11.0303 5.46967C11.171 5.61032 11.25 5.80109 11.25 6C11.25 6.19891 11.171 6.38968 11.0303 6.53033C10.8897 6.67098 10.6989 6.75 10.5 6.75H9C8.80109 6.75 8.61032 6.67098 8.46967 6.53033C8.32902 6.38968 8.25 6.19891 8.25 6ZM12.75 6C12.75 5.80109 12.829 5.61032 12.9697 5.46967C13.1103 5.32902 13.3011 5.25 13.5 5.25H15C15.1989 5.25 15.3897 5.32902 15.5303 5.46967C15.671 5.61032 15.75 5.80109 15.75 6C15.75 6.19891 15.671 6.38968 15.5303 6.53033C15.3897 6.67098 15.1989 6.75 15 6.75H13.5C13.3011 6.75 13.1103 6.67098 12.9697 6.53033C12.829 6.38968 12.75 6.19891 12.75 6ZM8.25 9.75C8.25 9.55109 8.32902 9.36032 8.46967 9.21967C8.61032 9.07902 8.80109 9 9 9H10.5C10.6989 9 10.8897 9.07902 11.0303 9.21967C11.171 9.36032 11.25 9.55109 11.25 9.75C11.25 9.94891 11.171 10.1397 11.0303 10.2803C10.8897 10.421 10.6989 10.5 10.5 10.5H9C8.80109 10.5 8.61032 10.421 8.46967 10.2803C8.32902 10.1397 8.25 9.94891 8.25 9.75ZM12.75 9.75C12.75 9.55109 12.829 9.36032 12.9697 9.21967C13.1103 9.07902 13.3011 9 13.5 9H15C15.1989 9 15.3897 9.07902 15.5303 9.21967C15.671 9.36032 15.75 9.55109 15.75 9.75C15.75 9.94891 15.671 10.1397 15.5303 10.2803C15.3897 10.421 15.1989 10.5 15 10.5H13.5C13.3011 10.5 13.1103 10.421 12.9697 10.2803C12.829 10.1397 12.75 9.94891 12.75 9.75ZM8.25 13.5C8.25 13.3011 8.32902 13.1103 8.46967 12.9697C8.61032 12.829 8.80109 12.75 9 12.75H10.5C10.6989 12.75 10.8897 12.829 11.0303 12.9697C11.171 13.1103 11.25 13.3011 11.25 13.5C11.25 13.6989 11.171 13.8897 11.0303 14.0303C10.8897 14.171 10.6989 14.25 10.5 14.25H9C8.80109 14.25 8.61032 14.171 8.46967 14.0303C8.32902 13.8897 8.25 13.6989 8.25 13.5ZM12.75 13.5C12.75 13.3011 12.829 13.1103 12.9697 12.9697C13.1103 12.829 13.3011 12.75 13.5 12.75H15C15.1989 12.75 15.3897 12.829 15.5303 12.9697C15.671 13.1103 15.75 13.3011 15.75 13.5C15.75 13.6989 15.671 13.8897 15.5303 14.0303C15.3897 14.171 15.1989 14.25 15 14.25H13.5C13.3011 14.25 13.1103 14.171 12.9697 14.0303C12.829 13.8897 12.75 13.6989 12.75 13.5Z"
                        fill="#09090B"
                    />
                </svg>
            </div>
            <div class="title">
                <h4>Request New Company</h4>
                <p>We strive to have the most comprehensive database of companies. If you don't see a company, please request it here.</p>
            </div>
        </div>

        <div class="input-container name-section">
            <label>Company Name</label>

            <prime-input-text
                placeholder="ACME Inc"
                v-model="companyName"
                :class="{ 'error': nameError }"
                @input="clearNameError"
                @keydown.enter="onEnter"
            />
            <div v-if="nameError" class="error-text">{{ nameError }}</div>
        </div>

        <div class="input-container url-section">
            <label>Company URL</label>

            <prime-input-text
                placeholder="https://companyurl.com"
                v-model="companyURL"
                :class="{ 'error': urlError }"
                @input="clearUrlError"
                @keydown.enter="onEnter"
            />
            <div v-if="urlError" class="error-text">{{ urlError }}</div>
        </div>

        <div class="actions-section">
            <prime-button variant="secondary" class="p-btn-root_secondary" @click="closeDialog">Cancel</prime-button>
            <prime-button
                label="Submit"
                :disabled="companyName === '' || companyURL === '' || isSubmitting"
                :loading="isSubmitting"
                @click="submit"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import ModalPattern from '~/assets/images/illustrations/modal-pattern.svg';
import { companiesService } from '~/services/companies-service';
import { ModalNames } from '~/types/modals';

const companyName = ref('');
const companyURL = ref('');
const isSubmitting = ref(false);
const nameError = ref('');
const urlError = ref('');

const dialogRef = getDialogRef(ModalNames.REQUEST_NEW_COMPANY);

const closeDialog = () => {
    dialogRef.value.close();
};

const clearNameError = () => {
    nameError.value = '';
};

const clearUrlError = () => {
    urlError.value = '';
};

const validateForm = () => {
    let isValid = true;

    // Clear previous errors
    nameError.value = '';
    urlError.value = '';

    // Validate company name
    if (!companyName.value || companyName.value.trim() === '') {
        nameError.value = 'Company name is required';
        isValid = false;
    }

    // Validate URL
    if (!companyURL.value || companyURL.value.trim() === '') {
        urlError.value = 'Company URL is required';
        isValid = false;
    } else {
        // Check if URL has proper format
        try {
            const url = new URL(companyURL.value.startsWith('http') ? companyURL.value : `https://${companyURL.value}`);

            // Validate hostname format
            if (!url.hostname || url.hostname.length < 3) {
                urlError.value = 'Please enter a valid company URL';
                isValid = false;
            } else {
                // Check for valid domain format (must have at least one dot and valid characters)
                const hostname = url.hostname.toLowerCase();
                const domainRegex = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*\.[a-z]{2,}$/;

                if (!domainRegex.test(hostname)) {
                    urlError.value = 'Please enter a valid company URL with a proper domain';
                    isValid = false;
                } else {
                    // Check for common invalid patterns
                    if (hostname.includes('..') || hostname.startsWith('.') || hostname.endsWith('.')) {
                        urlError.value = 'Please enter a valid company URL';
                        isValid = false;
                    }
                }
            }
        } catch (error) {
            urlError.value = 'Please enter a valid company URL';
            isValid = false;
        }
    }

    return isValid;
};

const submit = async () => {
    if (!validateForm()) {
        return;
    }

    isSubmitting.value = true;

    try {
        // Normalize URL format
        const normalizedURL = companyURL.value.startsWith('http') ? companyURL.value : `https://${companyURL.value}`;

        await companiesService.requestNewCompany(companyName.value.trim(), normalizedURL);
        useClientToast().success('Company request submitted successfully');
        closeDialog();
    } catch (error: any) {
        useClientToast().error(error.message || 'Failed to submit company request');
    } finally {
        isSubmitting.value = false;
    }
};

const onEnter = (e: KeyboardEvent) => {
    if (companyName.value !== '' && companyURL.value !== '' && !isSubmitting.value) {
        submit();
    }
};
</script>

<style lang="scss" scoped>
.close-icon {
    @apply absolute right-4 top-4 cursor-pointer p-1 rounded-full z-10 cursor-pointer ;
}
.header {
    @apply relative z-10 flex flex-row gap-4 justify-start ;

    .icon-container {
        @apply flex w-12 h-12 p-3 justify-center items-center rounded-lg border border-gray-200 bg-white shadow-cardshadow ;
    }
    .title {
        h4 {
            @apply text-gray-900 text-lg font-semibold leading-7 font-inter ;
        }
        p {
            @apply text-gray-600 text-sm font-normal leading-5 font-inter ;
        }
    }
}
.request-new-company-modal {
    @apply relative p-6 bg-white rounded sm:max-w-md sm:w-full w-11/12 mx-auto ;
}
.input-container {
    @apply flex flex-col gap-1;

    label {
        @apply text-gray-700 text-sm font-medium leading-5 font-inter ;
    }
    .error-text {
        @apply text-red-600 text-sm font-normal leading-5 mt-1 ;
    }
}
.name-section {
    @apply mt-5 relative z-10;
}
.url-section {
    @apply mt-4 relative z-10;
}
.actions-section {
    @apply flex gap-3 mt-8 justify-end relative z-10 ;
}
// Error state styles for PrimeVue input
:deep(.p-inputtext.error) {
    @apply border-red-500;

    &:focus {
        @apply border-red-500 ring-red-500 ;
    }
}
</style>
